import { Factory } from 'lucide-react';
import { cn } from '../../../lib/utils';

/**
 * Beside a product's name: the vetter this offer is assigned to, or that it has
 * none. Said outright either way — an empty space reads the same as "not
 * loaded". Read-only; the vetter is changed in Set pricing.
 */
export function VetterTag({ name }: { name: string | null }) {
	return (
		<span
			title={name ? `Vetter: ${name}` : 'No vetter assigned'}
			className={cn(
				'inline-flex items-center gap-1 text-xs font-normal',
				name ? 'text-text-3' : 'text-text-4'
			)}
		>
			<Factory size={12} className="shrink-0" />
			<span className="truncate">{name ?? 'No vetter'}</span>
		</span>
	);
}
